
import PropTypes from 'prop-types'
import React from 'react'
import './Sidebar.css'

const Sidebar = ({ children }) => <div className='Sidebar'>{children}</div>

Sidebar.displayName = 'Sidebar'

Sidebar.propTypes = {
  children: PropTypes.object
}

export default Sidebar



// WEBPACK FOOTER //
// ./ui/Sidebar.js